<template>
  <section class="policy-info__detail">
    <div class="podft-list p-4 rounded border mb-5">
      <div v-if="supportInfo.id" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Номер заявки
          <span class="text-gray-800 float-end" v-html="supportInfo.id"></span>
        </div>
      </div>
      <div v-if="supportInfo.creator.fio" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Создал
          <span class="text-gray-800 float-end" v-html="supportInfo.creator.fio"></span>
        </div>
      </div>
      <div v-if="supportInfo.support.fio" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Поддержка
          <span class="text-gray-800 float-end" v-html="supportInfo.support.fio"></span>
        </div>
      </div>
      <div v-if="supportInfo.created_at" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Дата создания заявки
          <span class="text-gray-800 float-end" v-html="supportInfo.created_at"></span>
        </div>
      </div>
      <div v-if="supportInfo.statusName" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Статус
          <span class="px-3 py-1 rounded text-white fs-9 fw-bold float-end" v-html="supportInfo.statusName" :class="getStyle(supportInfo.status)"></span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PolicySupportInfo',
  props: {
    supportInfo: null
  },
  methods: {
    getStyle(status) {
      if (status === 0) return 'bg-primary'
      if (status === 1) return 'bg-success'
      if (status === 2) return 'bg-danger'
      if (status >= 3 && status <= 10) return 'bg-warning'
    }
  }
}
</script>

<style scoped>

</style>